(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["oasis-available-land-cards"] && !Shopify.designMode) return;
  try {
    function initializeAvailableLandGrids() {
  document.querySelectorAll('[data-oasis-available-grid]').forEach(grid => {
    if (grid.dataset.ordered === 'true') return;
    grid.dataset.ordered = 'true';
    const oceanfrontCards = [...grid.querySelectorAll('.oceanfront-card')];
    const cards = [...grid.querySelectorAll('[data-lot-filter-item]:not(.oceanfront-card)')];
    const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });
    cards.sort((a, b) => Number(a.dataset.sortPrice) - Number(b.dataset.sortPrice) || collator.compare(a.querySelector('.plot-card-title')?.textContent.trim() || '', b.querySelector('.plot-card-title')?.textContent.trim() || ''));
    const size = Math.floor(cards.length / 3);
    let remainder = cards.length % 3;
    let cursor = 0;
    const buckets = Array.from({length:3}, () => {
      const length = size + (remainder > 0 ? 1 : 0);
      remainder = Math.max(0, remainder - 1);
      const bucket = cards.slice(cursor, cursor + length);
      cursor += length;
      return bucket;
    });
    for (let row = 0; row < Math.max(...buckets.map(bucket => bucket.length)); row++) {
      buckets.forEach(bucket => { if (bucket[row]) grid.appendChild(bucket[row]); });
    }
    oceanfrontCards.forEach(card => grid.appendChild(card));
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAvailableLandGrids, { once:true });
else initializeAvailableLandGrids();
document.addEventListener('shopify:section:load', initializeAvailableLandGrids);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["oasis-collection-refinements"] && !Shopify.designMode) return;
  try {
    (() => {
    function initCollectionRefinements() {
      if (!document.body.classList.contains('oasis-refined-collection')) return;
      const count = document.querySelector('[data-oasis-lot-count]');
      const grid = document.getElementById('product-grid');
      if (count && !count.dataset.connected) {
        count.dataset.connected = 'true';
        const update = (number) => {
          count.querySelector('[data-oasis-lot-number]').textContent = number;
          count.querySelector('[data-oasis-lot-label]').textContent = number === 1 ? count.dataset.one : count.dataset.many;
        };
        const refresh = () => update(grid ? [...grid.querySelectorAll('[data-lot-filter-item]:not(.oceanfront-card)')].filter(card => !card.hidden && card.style.display !== 'none').length : 0);
        document.addEventListener('lot-filter:change', refresh);
        if (grid) new MutationObserver(refresh).observe(grid, { childList: true });
        refresh();
      }
      const header = document.querySelector('.section-header');
      if (header && !header.dataset.collectionOffset) {
        header.dataset.collectionOffset = 'true';
        let pending = false;
        const updateOffset = () => {
          pending = false;
          const rect = header.getBoundingClientRect();
          const position = getComputedStyle(header).position;
          const bottom = position === 'sticky' || position === 'fixed' ? Math.max(0, rect.bottom) : 0;
          document.body.style.setProperty('--ol-header-bottom', `${Math.round(bottom)}px`);
        };
        const schedule = () => { if (!pending) { pending = true; requestAnimationFrame(updateOffset); } };
        new ResizeObserver(schedule).observe(header);
        window.addEventListener('scroll', schedule, { passive: true });
        window.addEventListener('resize', schedule, { passive: true });
        updateOffset();
      }
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initCollectionRefinements, { once: true });
    else initCollectionRefinements();
    document.addEventListener('shopify:section:load', initCollectionRefinements);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["oceanfront-interest-form"] && !Shopify.designMode) return;
  try {
    function redirectOceanfrontInterestSuccess() {
  const success = document.querySelector('[data-oceanfront-interest-success]');
  if (success) {
    window.location.replace(success.dataset.redirectUrl);
  }
  const error = document.querySelector('.oceanfront-interest__error');
  if (error) error.focus();
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', redirectOceanfrontInterestSuccess, { once: true });
} else {
  redirectOceanfrontInterestSuccess();
}
document.addEventListener('shopify:section:load', redirectOceanfrontInterestSuccess);
  } catch(e) { console.error(e); }
})();

})();
